import { PDF_GEN, UNIVERSAL_ADMIN, V4_UNIVERSAL_ADMIN } from '@lib/tools/helpers/constants';

const api = {
  urlFlats: process.env.NEXT_PUBLIC_MANAGERFORMA_API_FUll,
  urlAttributes: `${process.env.NEXT_PUBLIC_MANAGER_URL}/api/lot-attributes/list`,
  urlBulks: `${process.env.NEXT_PUBLIC_MANAGER_URL}/api/bulks?blockId=1457`,
  urlPdf: PDF_GEN,

  //Страница "Условия покупки", относительные пути апи работают через прокси
  urlHeaderKeysData: `${UNIVERSAL_ADMIN}/menu/header`,
  urlNavList: `${UNIVERSAL_ADMIN}/menu/purchase`,
  urlTradeIn: `${UNIVERSAL_ADMIN}/special_program/trade-in`,
  urlQa: `${UNIVERSAL_ADMIN}/qa`,
  urlSpecialMortgages: `${UNIVERSAL_ADMIN}/special_program/mortgage`,
  urlBuyout: `${UNIVERSAL_ADMIN}/special_program/buyout`,
  urlMortgages: `${UNIVERSAL_ADMIN}/special_program/mortgage-standard`,
  urlCalcData: `${V4_UNIVERSAL_ADMIN}/mortgages`,
  urlMortgageGroups: `${UNIVERSAL_ADMIN}/general_settings/mortgage_groups`,
  urlInstallments: `${UNIVERSAL_ADMIN}/special_program/installment`,
  urlSpecialInstallments: `${UNIVERSAL_ADMIN}/special_program/installment-main`,
  urlCash: `${UNIVERSAL_ADMIN}/special_program/cash`,
  urlCashback: `${UNIVERSAL_ADMIN}/special_program/cashback`,
  urlReferralProgram: `${UNIVERSAL_ADMIN}/special_program/referral_program`,
  urlPromoCards: `${V4_UNIVERSAL_ADMIN}/promo_cards`,
  urlComfortableMortgage: `${V4_UNIVERSAL_ADMIN}/promo_cards/comfortable_mortgage`,

  urlMainPromos: `${V4_UNIVERSAL_ADMIN}/promo_cards/promo`,

  urlGeneralSettings: `${UNIVERSAL_ADMIN}/general_settings`,
  urlGeneralTwoBlocksContent: `${V4_UNIVERSAL_ADMIN}/promo_cards/moments_season`,

  urlMainSlider: `${V4_UNIVERSAL_ADMIN}/promo_cards/slider_seasons`,

  // Страница "Документы"
  urlDocuments: `${V4_UNIVERSAL_ADMIN}/documents`,

  // Страница "Коммерция"
  urlPlacementsCommercialInfo: `${V4_UNIVERSAL_ADMIN.slice(0, -5)}/v4/1457/promo_cards/moments_comm`,

  // Страница "Школа"
  urlSchool: `${V4_UNIVERSAL_ADMIN}/single-page/school`,

  // Страница 'Пользовательское соглашение'
  urlPolicy: `${V4_UNIVERSAL_ADMIN}/single-page/policy`,

  // Страница "Новости"
  urlNews: `${V4_UNIVERSAL_ADMIN.slice(0, -5)}/v4/1457/news`,
  // Слайдер на странцие конкретной "Новости"
  urlNewsSlider: `${V4_UNIVERSAL_ADMIN}/slider`,

  // Страница "Ход строительства"
  urlProgress: `${V4_UNIVERSAL_ADMIN.replace('api/', 'api/v4/')}/progress`,
  urlProgressCompareSlider: `${V4_UNIVERSAL_ADMIN}/promo_cards/now_future`,

  // Страница 'Архитектура'
  urlArchitecture: `${V4_UNIVERSAL_ADMIN}/slider/architecture`,

  // Страница 'Галерея'
  urlGallery: `${V4_UNIVERSAL_ADMIN}/gallery`,

  // Хедер
  urlProfile:
    'https://client.forma.ru/auth?callbackPath=/objects/main?utm_source=lk&utm_medium=clients&utm_campaign=moments_site_button',

  //Меню
  urlMenuLeft: `${UNIVERSAL_ADMIN}/menu/burger-left`,
  urlMenuRight: `${UNIVERSAL_ADMIN}/menu/burger-right`,
  urlFooterLeft: `${UNIVERSAL_ADMIN}/menu/footer-left`,
  urlFooterRight: `${UNIVERSAL_ADMIN}/menu/footer-right`,
  urlFooterMiddle: `${UNIVERSAL_ADMIN}/menu/footer-middle`,
  urlDevelopers: `${UNIVERSAL_ADMIN}/general_settings/site_developer`,

  // Страница "Политика операторов"
  urlOperatorPolicy: `${V4_UNIVERSAL_ADMIN}/table_block/operator_policy_moments`,
  urlAdvertisingPolicy: `${V4_UNIVERSAL_ADMIN}/table_block/ads-consent_moments`,
  urlRedirects: `${UNIVERSAL_ADMIN.slice(0, -5)}/redirects`,

  // Промо плашка на странице
  urlPromoStrip: `${UNIVERSAL_ADMIN}/promo_cards/promo_list`,

  // Seo-фильтры
  urlSeoFilters: `${V4_UNIVERSAL_ADMIN}/seo_filters`,
  urlSeoFilterSearch: `${UNIVERSAL_ADMIN}/seo_filters/search`,
  urlSeoFilterPage: `${UNIVERSAL_ADMIN}/seo-page`,

  otherInformation: `${UNIVERSAL_ADMIN.replace('api', 'api/v2')}/other_information`,
  pikFinchMortgage: 'https://calculator.pik-service.ru/api/v1/programs',

  // Приемка квартиры
  urlBeforeInspection: `${UNIVERSAL_ADMIN.slice(0, -5)}/v4/1457/promo_cards/before_inspection`,
  urlAfterInspection: `${UNIVERSAL_ADMIN.slice(0, -5)}/v4/1457/promo_cards/after_inspection`,
  urlPropertyInspection: `${UNIVERSAL_ADMIN.slice(0, -5)}/v4/1457/promo_cards/property_inspection`,
  urlHelpfulMaterials: `${UNIVERSAL_ADMIN.slice(0, -5)}/v4/1457/promo_cards/helpful_materials02`,
  urlAfterInspectionDocuments: `${UNIVERSAL_ADMIN.slice(0, -5)}/v4/1457/promo_cards/documents_after_insp`,
};

export default api;
